import extractGlobalContent from '../operations/extract-global-content';

const normalizeText = (text) => text.replace(/\s+/g, ' ').trim();

const arrayBasedSettings = {
  ADDRESSES: 'addresses',
  EMAILS: 'emails',
  PHONES: 'phones',
  BUSINESS_HOURS: 'businessHours',
};

const globalToSettingMap = {
  addresses: arrayBasedSettings.ADDRESSES,
  emails: arrayBasedSettings.EMAILS,
  phones: arrayBasedSettings.PHONES,
  'business-hours': arrayBasedSettings.BUSINESS_HOURS,
};

const getChangedSettingsAccordingToGlobalContent = (settings) => {
  const changedSettings = {};

  if (!settings) {
    return changedSettings;
  }

  Object.entries(globalToSettingMap).forEach(([globalKey, settingsKey]) => {
    const globalNode = extractGlobalContent(globalKey);
    const globalText = normalizeText(globalNode?.innerText || '');

    const settingArray = settings[settingsKey] || [];
    const settingValue = normalizeText(settingArray.join(' '));

    if (settingValue !== globalText) {
      changedSettings[settingsKey] = settings[settingsKey];
    }
  });

  return changedSettings;
};

export default getChangedSettingsAccordingToGlobalContent;
